import Vue from 'vue'
import App from './App'
import router from './router'

// api
import api from './request/api.js'
// axios
import axios from './request/https.js'
import VueAxios from 'vue-axios'



// vant
import 'vant/lib/index.css';
import {
  Dialog,
  Toast,
  Swipe,
  SwipeItem,
  Lazyload,
  Col,
  Button,
  Row,
  Form,
  Collapse,
  CollapseItem,
  Checkbox,
  CheckboxGroup,
  DatetimePicker,
  Rate,
  Picker,
  Overlay,
  Tab,
  Tabs,
  RadioGroup,
  Radio,
  DropdownMenu,
  DropdownItem,
  Uploader,
  List,
  Popover,
  Popup,
  Divider,
  Sticky,
  Field,
  Panel,
  ImagePreview,
  Area,
  Calendar,
  IndexBar,
  IndexAnchor
} from 'vant';
import { Image as VanImage } from 'vant';
Vue.use(VueAxios, axios)
Vue.use(Toast)
Vue.use(Swipe);
Vue.use(Form);
Vue.use(Button);
Vue.use(SwipeItem);
Vue.use(Lazyload)
Vue.use(Col);
Vue.use(Row);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(DatetimePicker);
Vue.use(Rate);
Vue.use(Picker);
Vue.use(Overlay);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Uploader);
Vue.use(List);
Vue.use(Popover);
Vue.use(Popup);
Vue.use(Divider);
Vue.use(Sticky);
Vue.use(Field);
Vue.use(Panel);
Vue.use(Dialog)
Vue.use(ImagePreview);
Vue.use(Area);
Vue.use(Calendar);
Vue.use(VanImage);
Vue.use(IndexBar);
Vue.use(IndexAnchor);
// loading
import './common/loading/loading.css';
import Loading from './common/loading/loading';
Vue.use(Loading);
// cookie
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

// qs
import qs from 'qs';
Vue.prototype.$axios = axios
axios.defaults.baseURL = ''
// animated
import animated from 'animate.css'
Vue.use(animated)
// v-touch
import VueTouch from 'vue-touch';
Vue.use(VueTouch, {
  name: 'v-touch'
});
VueTouch.config.swipe = {
  threshold: 10 //手指左右滑动触发事件距离
}

// QRCode
import QRCode from 'qrcode'

// 粘贴板
import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;
// 防止重复加载
import preventReClick from './lib/preventReClick.js' //防多次点击，重复提交

Vue.prototype.api = api
Vue.config.productionTip = false

// 引入VueX
import store from './store/index.js';



// // 创建VConsole
// import VConsole from 'vconsole'
// const vConsole = new VConsole()
// Vue.use(vConsole)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js